import { useState, useCallback } from 'react'

export const useUnsavedChangesPrompt = onConfirm => {
  const [unsavedChanges, setUnsavedChanges] = useState(false)
  const [showConfirmation, setShowConfirmation] = useState(false)

  const handleConfirm = useCallback(() => {
    setShowConfirmation(false)
    if (onConfirm) {
      onConfirm()
    }
  }, [onConfirm])

  const handleCancel = useCallback(() => {
    setShowConfirmation(false)
  }, [])

  const promptIfUnsaved = useCallback(() => {
    if (unsavedChanges) {
      setShowConfirmation(true)
    } else {
      if (onConfirm) {
        onConfirm()
      }
    }
  }, [unsavedChanges, onConfirm])

  return {
    unsavedChanges,
    setUnsavedChanges,
    showConfirmation,
    handleConfirm,
    handleCancel,
    promptIfUnsaved,
  }
}
